import { z } from "zod";

// Date schema matching proto Date message
const dateSchema = z.object({
  year: z.string(),
  month: z.string(),
  day: z.string(),
});

// Page schema matching proto Page message
const pageSchema = z.object({
  title: z.string().nullable(),
  url: z.string().nullable(),
  type: z.string().nullable(),
  category: z.string().nullable(),
  region: z.string().nullable(),
  tags: z.array(z.string()).nullable(),
  number: z.string().nullable(),
  index: z.number().nullable(),
  view_type: z.string().nullable(),
  country_code: z.string().nullable(),
});

// Product schema matching proto Product message
const productSchema = z.object({
  primary: z
    .object({
      name: z.string().nullable(),
      brand: z.string().nullable(),
      category: z.string().nullable(),
    })
    .nullable(),
  secondary: z
    .object({
      products: z.array(z.string()).nullable(),
      brands: z.array(z.string()).nullable(),
    })
    .nullable(),
  source: z.string().nullable(),
});

// Article schema matching proto Article message
const articleSchema = z.object({
  verticals: z.array(z.string()).nullable(),
  sub_verticals: z.array(z.string()).nullable(),
  language: z.string().nullable(),
  authors: z.array(z.string()).nullable(),
  id: z.string().nullable(),
  publish_date: dateSchema.nullable(),
  update_date: dateSchema.nullable(),
  legacy_id: z.string().nullable(),
});

// Classification schema matching proto Classification message
const classificationSchema = z.object({
  google: z
    .array(
      z.object({
        name: z.string(),
        confidence: z.number(),
      })
    )
    .nullable(),
  iab: z
    .array(
      z.object({
        label: z.string(),
        score: z.number(),
        category_id: z.string(),
      })
    )
    .nullable(),
});

// Content schema matching proto Content message
const contentSchema = z.object({
  article: articleSchema.nullable(),
  classification: classificationSchema.nullable(),
});

// Site schema matching proto Site message
const siteSchema = z.object({
  region: z.string().nullable(),
  brand: z.string().nullable(),
  country_code: z.string().nullable(),
});

// Experiment schema matching proto Experiment message
const experimentSchema = z.object({
  id: z.string().nullable(),
  name: z.string().nullable(),
  variant_id: z.number().nullable(),
  variant_name: z.string().nullable(),
  experiment_source: z.string().nullable(),
});

// User schema matching proto User message
const userSchema = z.object({
  browser: z
    .object({
      type: z.string().nullable(),
      family: z.string().nullable(),
      version: z.string().nullable(),
      major_version: z.string().nullable(),
    })
    .nullable(),
  os: z
    .object({
      name: z.string().nullable(),
      version: z.string().nullable(),
    })
    .nullable(),
  device: z
    .object({
      model: z.string().nullable(),
      vendor: z.string().nullable(),
    })
    .nullable(),
  cpu: z
    .object({
      architecture: z.string().nullable(),
    })
    .nullable(),
  logged_in: z.boolean().nullable(),
  hybrid_id: z.string().nullable(),
  kiosq_id: z.string().nullable(),
  user_grant_status: z.string().nullable(),
  blue_conic_id: z.string().nullable(),
  ga_client_id: z.string().nullable(),
  gclid: z.string().nullable(),
  sha256_email_hash: z.string().nullable(),
  screen_width: z.number().nullable(),
  ua: z.string().nullable(),
  referrer: z.string().nullable(),
});

// Timestamp schema matching proto Timestamp message
const timestampSchema = z.object({
  start_time: z.string().nullable(), // google.protobuf.Timestamp as ISO string
  end_time: z.string().nullable(), // google.protobuf.Timestamp as ISO string
});

// Main ProductLikedEvent schema matching proto ProductLikeEvent message
const productLikedEventSchema = z
  .object({
    page: pageSchema.nullable(),
    content: contentSchema.nullable(),
    site: siteSchema.nullable(),
    product: productSchema.nullable(),
    experiment: experimentSchema.nullable(),
    user: userSchema.nullable(),
    timestamp: timestampSchema.nullable(),
  })
  .partial();

export default productLikedEventSchema;
